import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CustomColumnHeader.module.css';
import TextWithDefinition from '../../TextWithDefinition';

const CustomColumnHeader = (props) => {
	const [ascSort, setAscSort] = useState('inactive');
	const [descSort, setDescSort] = useState('inactive');
	const [, setNoSort] = useState('inactive');

	const onSortChanged = () => {
		setAscSort(props.column.isSortAscending() ? 'active' : 'inactive');
		setDescSort(props.column.isSortDescending() ? 'active' : 'inactive');
		setNoSort(
			!props.column.isSortAscending() && !props.column.isSortDescending()
				? 'active'
				: 'inactive'
		);
	};

	const onSortRequested = (event) => {
		if (ascSort === 'active') {
			setAscSort('inactive');
			setDescSort('active');
			props.setSort('desc', event.shiftKey);
		} else {
			setDescSort('inactive');
			setAscSort('active');
			props.setSort('asc', event.shiftKey);
		}
	};

	useEffect(() => {
		props.column.addEventListener('sortChanged', onSortChanged);
		onSortChanged();
	}, []);

	const SortIcon = () => {
		if (ascSort === 'active') {
			return (
				<span className={`ag-icon ag-icon-asc`} role="presentation"></span>
			);
		} else if (descSort === 'active') {
			return (
				<span className={`ag-icon ag-icon-desc`} role="presentation"></span>
			);
		} else {
			return <></>;
		}
	};

	const textStyle = {
		flexDirection: 'row',
		justifycontent: 'flex-end',
		display: 'flex',
	};

	return (
		<div
			role="none"
			style={{
				justifyContent: props?.leftAlign ? 'flex-start' : 'flex-end',
				paddingLeft: '16px',
				paddingRight: props.isStoreDrilldown ? '16px' : '0px',
			}}
			className={styles.customHeaderLabel}
			onKeyDown={(event) => onSortRequested(event)}
			onClick={(event) => onSortRequested(event)}
			onTouchEnd={(event) => onSortRequested(event)}>
			<SortIcon />
			<TextWithDefinition
				text={props.displayName}
				styles={{
					...textStyle,
					fontSize: '14px !important',
					fontWeight: '700 !important',
					fontFamily: 'Bogle-Regular !important',
				}}
				definitionId={props.definitionId}
				hasDefinition={props.hasDefinition}
			/>
		</div>
	);
};

CustomColumnHeader.propTypes = {
	value: PropTypes.string,
	metricDefinition: PropTypes.string,
	column: PropTypes.any,
	displayName: PropTypes.string,
	setSort: PropTypes.func,
	enableSorting: PropTypes.bool,
	hasDefinition: PropTypes.bool,
	definitionId: PropTypes.string,
	leftAlign: PropTypes.bool,
	isStoreDrilldown: PropTypes.bool,
};

export default CustomColumnHeader;
